import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import { api } from '@/api/api'
import { rotasApiAutenticadoV5 } from '@/configurações/rotasApi/rotasApiAutenticadoV5'
import { primeiroAcessoRotasApp } from '@/páginas/publicas/primeiroAcesso/primeiroAcesso.routes'
import {
  responseError,
  responseSuccess,
} from '@/utilitários/handler/responseHandler'
import { zodResolver } from '@hookform/resolvers/zod'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { z } from 'zod'

const { path } = rotasApiAutenticadoV5.buscarMatricula
export const useAuthConfirmarMatriculaV5 = () => {
  const navigate = useNavigate()
  const context = useForm<SchemaMatricula>({
    resolver: zodResolver(schema),
    mode: 'onChange',
  })

  const { status, isLoading, mutate } = useMutation({
    mutationFn: endPoint,
    onError: (error: AxiosError) => responseError(error),
    onSuccess: () => {
      localStorage.setItem('matricula', context.getValues('matricula'))
      responseSuccess('Matrícula verificada')
      navigate(primeiroAcessoRotasApp.cadastro)
    },
  })

  return {
    statusAuthBuscarMatricula: status,
    isLoadingAuthBuscarMatricula: isLoading,
    mutateAuthBuscarMatricula: mutate,
    contextAuthBuscarMatricula: context,
  }
}

async function endPoint(
  data: SchemaMatricula,
): Promise<ServiceResponseAuthBuscarMatriculaV5> {
  const result = await api().get(path(data.matricula))
  return result.data.data
}

const schema = z.object({
  matricula: z.string({ message: 'Campo obrigatório' }),
})

export type SchemaMatricula = z.infer<typeof schema>

export interface ServiceResponseAuthBuscarMatriculaV5 {
  instituicoes: Array<{
    id: string
    nome: string
  }>
}
